/**
 *
 * @param {*} arr Stack
 * @param {*} needle Find tag
 */
const isTagged = (arr, needle) => {
  if (!arr) return false;

  return arr.some(item => item.toLowerCase().includes(needle.toLowerCase()));
};

export default isTagged;
